import { dataProvider } from "data";
import {
  CREATE_COMBO_PAYMENT_LINK,
  DUPLICATE_PAYMENT_LINK,
  PAYMENT_LINK_APIS,
} from "features/PaymentLinks/constants/PaymentLinks.apis";
import { apiMethods } from "data/api.constants";
import { useCustomMutation } from "data/modules/api/hooks/useCustomMutation";
import { isRequestSuccessful } from "utils/Utils";
import {
  IPaymentLinkApiPayload,
  IPaymentLinkMetadata,
} from "../interfaces/IPaymentLinkApiPayload";
import { ICreatePaymentLinkFormHoc } from "../modules/CreatePaymentLinkFormHoc/interfaces/ICreatePaymentLinkFormHoc";

export const createPaymentLink = async (payload: IPaymentLinkApiPayload) => {
  return dataProvider.custom_request(
    PAYMENT_LINK_APIS.generate_payment_link,
    apiMethods.POST,
    payload
  );
};

export const updatePaymentLink = async (
  paymentLinkId: string,
  payload: Pick<IPaymentLinkApiPayload, "title" | "expiry_date"> & {
    metadata?: IPaymentLinkMetadata;
  }
) => {
  const { data, status } = await dataProvider.custom_request(
    PAYMENT_LINK_APIS.update_payment_link,
    apiMethods.POST,
    { dynamic_link_id: paymentLinkId, updated_values: payload }
  );

  if (!isRequestSuccessful(status))
    throw new Error(`Error updating payment link: ${data} ${status}`);
};

export const createComboPaymentLink = async (payload: {
  listings: ICreatePaymentLinkFormHoc.IFormState["listingsPayload"];
  link_price: number;
  currency: string;
  payment_link_type: number;
  title: string;
  metadata?: IPaymentLinkMetadata;
}) => {
  return dataProvider.custom_request(
    CREATE_COMBO_PAYMENT_LINK,
    apiMethods.POST,
    payload
  );
};

export const useDuplicatePaymentLink = (options: any = {}) => {
  return useCustomMutation({
    url: DUPLICATE_PAYMENT_LINK,
    ...options,
  });
};
